import ForbiddenError from '../domain/forbidden-error';
import shopifyV1Client from '../infrastructure/acerill/shopify-v1-client';
import authenticationService from '../services/authentication-service';

const findMainThemeWithAuthErrorHandling = () => {
  return shopifyV1Client.findCurrentTheme()
    .catch(err => {
      if (err instanceof ForbiddenError) {
        return authenticationService
          .redirectToLoginUrl(null, ['read_themes', 'write_themes'])
          .then(() => null);
      } else {
        throw err;
      }
    });
};

const buildThemeTemplateSuffix = templateName => templateName.toLowerCase().replace(/ /g, '-');

const shopifyThemeService = {
  findMainThemeWithAuthErrorHandling,
  buildThemeTemplateSuffix,
};

export default shopifyThemeService;
